import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { RiFileExcel2Fill } from "react-icons/ri";

import { SearchInput } from "@/components/SearchInput";

type IndicatorEsbB4HealthTeamsFiltersProps = {
	search: string;
	setSearch: (search: string) => void;
	handleExportTable: () => void;
};

export function IndicatorEsbB4HealthTeamsFilters({
	search,
	setSearch,
	handleExportTable,
}: Readonly<IndicatorEsbB4HealthTeamsFiltersProps>) {
	return (
		<Row className="d-flex align-items-center w-100 justify-content-between">
			<Col sm={12} md={12} lg={6} xl={6}>
				<div className="fw-bolder">Classificação das equipes</div>
			</Col>
			<Col sm={12} md={12} lg={4} xl={4}>
				<div className="d-flex align-items-center gap-2 w-100 justify-content-end">
					<div className="w-100 min-w-lg-300px max-w-lg-300px">
						<SearchInput
							placeholder="Buscar por nome ou ine"
							value={search}
							setValue={setSearch}
							width={"100%"}
						/>
					</div>
					<Button
						title="Exportar planilha"
						variant="success"
						className="py-2 px-4"
						onClick={handleExportTable}
					>
						<RiFileExcel2Fill />
					</Button>
				</div>
			</Col>
		</Row>
	);
}
